export const createCookie = (name, value) => {
    document.cookie = `${name}=${value}`;
}
